<template>
  <div class="container dark:bg-gray-900 dark:text-gray-300">
    <p
      class="p-4 text-xl font-bold leading-none sm:px-0 sm:pt-8 md:pt-12 font-display lg:text-4xl"
    >
      {{ $t("categories") }}
    </p>
    <div class="sm:pb-24">
      <ClientOnly>
        <VList
          endpoint="categories"
          :params="{ variables: { hash } }"
          :per-page="-1"
        >
          <template #empty>
            <EmptyList title="No Categories Found!" icon="IcTwotoneCategory" />
          </template>
          <template #loading>
            <div class="category-grid">
              <ShimmerCategory v-for="n in 30" :key="`shimmer-${n}`" />
            </div>
          </template>
          <template #loading-page>
            <div class="category-grid">
              <ShimmerCategory v-for="n in 30" :key="`shimmer-${n}`" />
            </div>
          </template>
          <template #default="response">
            <div class="category-grid">
              <StoreCategory
                v-for="category in response.items"
                :key="`category-${category.id}`"
                :name="category.name"
                :count="category.categoryStatistics.activeProductCount"
                :slug="category.slug"
                :media="category.media"
              />
            </div>
          </template>
        </VList>
      </ClientOnly>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useBizStore } from "@/store/index.js";

export default {
  setup() {
    definePageMeta({
      layout: "store",
      scrollToTop: true,
    });
  },

  head() {
    return {
      title: "Categories",
      meta: [
        {
          hid: "og:title",
          property: "og:title",
          content: "Categories",
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "category-list",
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `${this.url}/categories`,
        },
      ],
    };
  },
  computed: {
    ...mapState(useVepaarStore, ["hash"]),
    ...mapState(useBizStore, ["name", "desc", "url"]),
  },
};
</script>

<style>
.category-grid {
  @apply grid grid-cols-2 p-4 rounded;
  @apply md:grid-cols-6 sm:gap-2;
}
</style>
